// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"85e81056","488":"e01f6245"}[chunkId] + ".chunk.js");